import type {User} from "@/components/users/scripts/types";
import {createEmptyUser} from "@/components/users/scripts/userActions";

const selectUser = (users: User[], userId: number) => {
    let selectedUser: User | undefined = undefined;

    if(userId && users.length > 0){
      selectedUser = users.find(user => user.id === userId) as User;
    }

    if(!selectedUser){
      selectedUser = users.length > 0 ? users[0] : createEmptyUser();
    }

    return selectedUser;
};

export {
    selectUser
}
